import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const addLeadingZero = (number: number) => {
  const newNumber = new Intl.NumberFormat('en-US', {
    minimumIntegerDigits: 2,
  });

  return newNumber.format(number);
};

export const formatDate = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  var timestamp = Date.parse(dateString);

  if (isNaN(timestamp) === false) {
    var date = new Date(timestamp);

    return `${addLeadingZero(date.getDate())}/${addLeadingZero(
      date.getMonth() + 1
    )}/${date.getFullYear()} ${addLeadingZero(date.getHours())}:${addLeadingZero(date.getMinutes())}:${addLeadingZero(
      date.getSeconds()
    )}`;
  }

  return '';
};

export const formatTime = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  const dateTime = getDateWithTimeZone(dateString);

  if (dateTime && dateTime.isValid()) {
    return `${addLeadingZero(dateTime.hour())}:${addLeadingZero(dateTime.minute())}`;
  }

  return '';
};

export const getTomorrowsDate = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  return tomorrow;
};

export const getTimestampWithMilliseconds = (value: any) => {
  if (value && dayjs.isDayjs(value)) {
    if (value.isValid()) {
      return value.valueOf();
    } else {
      return null;
    }
  }

  if (value) {
    return value;
  }

  return null;
};

export const getDateWithTimeZone = (str: dayjs.ConfigType) => {
  if (!str) {
    return null;
  }

  const dayjsDateWithTimezone = dayjs(str).tz(window.ENV.TIME_ZONE as string);
  return dayjsDateWithTimezone;
};

export const getDateStringWithTimeZone = (str: dayjs.ConfigType, dayjsFormat?: string) => {
  if (!str) {
    return '';
  }

  const dayjsDateWithTimezone = getDateWithTimeZone(str);
  return dayjsFormat ? dayjsDateWithTimezone?.format(dayjsFormat) : dayjsDateWithTimezone?.format();
};

export const getTimeFromString = (date: dayjs.ConfigType, time: string) => {
  if (!date || !time || (dayjs.isDayjs(date) && !date.isValid())) {
    return null;
  }

  const timeArray = time.split(':');
  const dateWithTimeZone = getDateWithTimeZone(date);
  const timeDayjsWithTimezone = dateWithTimeZone?.hour(parseInt(timeArray[0])).minute(parseInt(timeArray[1]));
  return timeDayjsWithTimezone?.format();
};
